import { render, staticRenderFns } from "./borgle.vue?vue&type=template&id=7e1c43d4&scoped=true&"
import script from "./borgle.vue?vue&type=script&lang=js&"
export * from "./borgle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1c43d4",
  null
  
)

export default component.exports